import moment from "moment";
import Vue from "vue";
import { router } from "@/router";
import _ from "lodash";
import store from "@/store";

function initialState() {
  return {
    cityModalModal: false,
    cityModalModalId: "cityModal",
    cinemaModalModal: false,
    cinemaModalModalId: "cinemaModal",

    safetyPopupModal: false,
    safetyPopupModalId: "safetyPopup",

    verifyBookingModal: false,
    verifyBookingModalId: "cinemaModal",

    signUpModal: false,
    signUpModalId: "signUp",
    signInModal: false,
    signInModalId: "signIn",
    otpModal: false,
    otpId: "otp",
    otpVerifiedModal: false,
    otpVerifiedModalId: "otpVerified",

    asideNavigation: false,

    fnbAdModalShown: false
  };
}
const state = initialState();

const mutations = {
  ON_SET_FNB_MODAL_SHOWN: (state, payload) => {
    state.fnbAdModalShown = payload;
  },
  ON_RESET_MODAL_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  ON_SET_MODAL_STATE_OPEN_STATUS: (state, payload) => {
    state[payload] = true;
    state.asideNavigation = false;
  },
  ON_SET_MODAL_STATE_CLOSE_STATUS: (state, payload) => {
    state[payload] = false;
  },
  ON_SET_MODAL_STATE_TOGGLE_STATUS: (state, payload) => {
    state[payload] = !state[payload];
    state[payload] ? (state.asideNavigation = false) : undefined;
  },
  ON_SET_SIDE_NAVIGATION_STATUS: (state, payload) => {
    state.asideNavigation = !state.asideNavigation;
  }
};

const actions = {
  onResetModalStoreState: async ({ dispatch, commit, state }, payload) => {
    await commit("ON_RESET_MODAL_STORE_STATE");
  },
  onHandleOpenModal: async ({ dispatch, commit, state }, payload) => {
    await commit("ON_RESET_MODAL_STORE_STATE", payload);
    await commit("ON_SET_MODAL_STATE_OPEN_STATUS", payload);
  },
  onHandleCloseModal: async ({ dispatch, commit, state }, payload) => {
    await commit("ON_RESET_MODAL_STORE_STATE", payload);
    await commit("ON_SET_MODAL_STATE_CLOSE_STATUS", payload);
    // await commit('ON_RESET_USER_STORE_STATE');
  },
  onHandleToggleModal: async ({ dispatch, commit, state }, payload) => {
    await commit("ON_SET_MODAL_STATE_TOGGLE_STATUS", payload);
  },
  onOpenAsideNavigation: async ({ dispatch, commit, state }, payload) => {
    await commit("ON_SET_SIDE_NAVIGATION_STATUS", payload);
  }
};

const getters = {
  getModals: state => state,
  getAsideNavigation: state => state.asideNavigation
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/ModalStore.js